import axios from "axios";
import { getToken, setToken, removeToken } from "@/utils/auth";
import router from "@/router";
import { showError, showSuccess } from "@/utils/notifications";
import store from "@/store";

function handleUnAuthorizeResponse() {
    router.go("/login?redirect=" + router.currentRoute.fullPath);
}

let lastErrorMessage = null;

// Create axios instance
const service = axios.create({
    baseURL: '/api',
    timeout: 60000 // Request timeout
});

// Request interceptor
service.interceptors.request.use(
    config => {
        const token = getToken();
        if (token) {
            config.headers["Authorization"] = "Bearer " + getToken(); // Set JWT token
        }
        return config;
    },
    error => {
        // Do something with request error
        console.log(error); // for debug
        Promise.reject(error);
    }
);

// response pre-processing
service.interceptors.response.use(
    response => {
        if (response.headers.authorization) {
            setToken(response.headers.authorization);
        }

        if (response.data.message && response.data.message != "ok") {
            showSuccess(response.data.message);
        }

        return response.data;
    },
    error => {
        if (error.response.status === 401 && getToken()) {
            removeToken();
            handleUnAuthorizeResponse();
        }

        let message = error.message;
        if (message === "timeout of 30000ms exceeded") {
            showError(
                "Something went wrong or the internet connection is weak"
            );
        } else {
            if (error.response.data && error.response.data.errors) {
                let errors = Object.values(error.response.data.errors);
                errors = errors.flat();
                message = errors[0];
            } else if (error.response.data && error.response.data.error) {
                message = error.response.data.error;
            } else if (error.response.data && error.response.data.message) {
                message = error.response.data.message;
            }

            if (message != lastErrorMessage) {
                if (error.config.withoutErrorMessages) {
                    store.dispatch("errors/setError", message);
                } else {
                    showError(message);
                }

                lastErrorMessage = message;
            }

            setTimeout(() => {
                lastErrorMessage = null;
            }
            , 3000);
        }

        return Promise.reject(error);
    }
);

export default service;
